import { createSlice } from '@reduxjs/toolkit'
import {
  operationsSliceConfig as operationsSliceBaseConfig,
  operationsSliceExtraReducers as operationsSliceBaseExtraReducers,
  deleteOperations,
} from 'apps/formsCreationKit/store/reducers/entities/operations'
import { deleteElement, replacePdf } from 'apps/studio/store/actions/sharedActions'

const operationsSliceStudioExtraReducers = builder => {
  builder.addCase(deleteElement, (state, action) => {
    const { entry } = action.payload
    return deleteOperations(state, entry.guid)
  })
  builder.addCase(replacePdf, (state, action) => {
    const { removedEntryGuids } = action.payload
    return removedEntryGuids.reduce(
      (currentState, guid) => deleteOperations(currentState, guid),
      state
    )
  })
}

export const operationsSliceStudioConfig = {
  ...operationsSliceBaseConfig,
  extraReducers: builder => {
    operationsSliceBaseExtraReducers(builder)
    operationsSliceStudioExtraReducers(builder)
  },
}

export const operationsSlice = createSlice(operationsSliceStudioConfig)
export const { actions: operationsActions, reducer: operationsReducer } =
  operationsSlice
